var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContextMenu',{attrs:{"buttons":_vm.buttons,"ariaLabel":"Otwórz kontekstowe menu kolumny"}}),_c('SettleCoursesConfirmDialog',{attrs:{"showDialog":_vm.value},on:{"confirm":_vm.onConfirmActionsClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }